import { GetStaticProps } from 'next'

import query from './queries'

import initApollo, { API } from 'src/api'

export type Props = API.Generic_genericPage

export const createGetStaticProps: (slug: string) => GetStaticProps<Props> = (slug) => async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Generic>({
    query,
    variables: {
      slug,
    },
  })

  if (!data.genericPage) {
    throw new Error()
  }

  return {
    props: data.genericPage,
  }
}
